import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';

import {required} from 'utils/validators';
import {cancelBooking} from 'ducks/bookings/detail';

import Label from 'components/Label';
import ErrorBlock from 'components/ErrorBlock';
import FormField from 'components/FormField';
import {TextField} from 'components/Fields';

const formSubmit = (values, dispatch, props) => {
  const {bookingId} = props;
  const {cancelledReason} = values;

  const extraActions = props.getExtraActions();
  dispatch(cancelBooking({bookingId, cancelledReason}, extraActions));
};

class CancelBookingForm extends React.Component<any> {
  render() {
    const {error, handleSubmit} = this.props;

    return (
      <form onSubmit={handleSubmit} className="CancelBookingForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Label>Cancelled Reason</Label>
          <Field
            name="cancelledReason"
            component={TextField}
            validate={[required]}
          />
        </FormField>
      </form>
    );
  }
}

export default connect(null, null)(
  reduxForm({form: 'cancelBooking', onSubmit: formSubmit})(CancelBookingForm)
);
